const compareImages = {
	"images": [
		{
			"title": "“Cosmic Cliffs” of the Carina Nebula",
			"titleSpanish": "“Acantilados Cósmicos” de la nebulosa Carina",
			"beforeImage": "CosmicCliffs_JWST.jpg",
			"afterImage": "CosmicCliffs_hubble.jpg",
			"thumbnail": "CosmicCliffs_thumb.jpg",
			"hubbleDesc": "Composite image taken with the Advanced Camera for Surveys (ACS) in 2006, and the Wide Field Planetary Camera 2 (WFPC2) in 2008.",
			"webbDesc": "With the crisp resolution and unparalleled sensitivity of the Near-Infrared Camera (NIRCam), this 2022 image reveals previously obscured areas of star birth.",
			"hubbleDescSpanish": "Imagen compuesta tomada con la Cámara Avanzada para Sondeos (ACS) en 2006 y la Cámara Planetaria de Campo Amplio 2 (WFPC2) en 2008.",
			"webbDescSpanish": "Con la resolución nítida y la sensibilidad incomparable de la cámara de infrarrojo cercano (NIRCam), esta imagen del 2022 revela áreas de nacimiento de estrellas previamente oscurecidas.",
			"hubbleCredits": "Credit: NASA, ESA, and The Hubble Heritage Team (STScI/AURA)",
			"webbCredits": "Credit: NASA, ESA, CSA, STScI",
			"titleDesc": "1 Lorem ipsum dolor sit amet, consectetur adipiscing elit",
		},
		{
			"title": "Jupiter",
			"titleSpanish": "Júpiter",
			"beforeImage": "jupiter_JWST.jpg",
			"afterImage": "jupiter_hubble.jpg",
			"thumbnail": "jupiter_thumb.jpg",
			"hubbleDesc": "This 2020 visible-light image of Jupiter shows the planet’s turbulent atmosphere and Great Red Spot.",
			"webbDesc": "This image taken with the NIRCam (Near-Infrared Camera) in 2023, uncovers spectacular details of the planet in infrared light.",
			"hubbleDescSpanish": "Esta imagen de Júpiter en luz visible de 2020 muestra la atmósfera turbulenta del planeta y la Gran Mancha Roja.",
			"webbDescSpanish": "Esta imagen tomada con la NIRCam (Cámara de Infrarrojo Cercano) en 2023, descubre detalles espectaculares del planeta en luz infrarroja.",
			"hubbleCredits": "Credit: NASA, ESA, A. Simon (Goddard Space Flight Center), and M. H. Wong (University of California, Berkeley) and the OPAL team",
			"webbCredits": "Credit: NASA, ESA, CSA, STScI, Ricardo Hueso (UPV), Imke de Pater (UC Berkeley), Thierry Fouchet (Observatory of Paris), Leigh Fletcher (University of Leicester), Michael H. Wong (UC Berkeley), Joseph DePasquale (STScI)",
			"titleDesc": "2 Lorem ipsum dolor sit amet, consectetur adipiscing elit",
		},
		{
			"title": "Southern Ring Nebula",
			"titleSpanish": "La nebulosa del Anillo Sur",
			"beforeImage": "SouthernRingNebula_JWST.jpg",
			"afterImage": "SouthernRingNebula_hubble.jpg",
			"thumbnail": "SouthernRingNebula_thumb.jpg",
			"hubbleDesc": "Released in 2013, this visible-light image has become one of Hubble’s most iconic images.",
			"webbDesc": "Captured with the NIRCam (Near-InfraRed Camera) in 2023, this image unveils unprecedented resolution and spectral sensitivity.",
			"hubbleDescSpanish": "Publicada en 2013, esta imagen en luz visible se ha convertido en una de las imágenes más icónicas del Hubble.",
			"webbDescSpanish": "Capturada con la NIRCam (cámara de infrarrojo cercano) en 2023, esta imagen revela una resolución y una sensibilidad espectral sin precedentes.",
			"hubbleCredits": "Credit: NASA, ESA, and C. Robert O’Dell (Vanderbilt University)",
			"webbCredits": "Credit: ESA/Webb, NASA, CSA, M. Barlow, N. Cox, R. Wesson",
			"titleDesc": "3 Lorem ipsum dolor sit amet, consectetur adipiscing elit",
		},
		{
			"title": "Tarantula Nebula",
			"titleSpanish": "La nebulosa Tarántula",
			"beforeImage": "TarantulaNebula_JWST.jpg",
			"afterImage": "TarantulaNebula_hubble.jpg",
			"thumbnail": "TarantulaNebula_thumb.jpg",
			"hubbleDesc": "A 2014 composite image taken in visible, infrared and ultraviolet light, this nebula is full of star clusters, glowing gas and thick, dark dust.",
			"webbDesc": "Seeing straight through the cosmic dust with the Near-Infrared Camera (NIRCam), the infrared wavelengths expose tens of thousands of never-before-seen young stars in this 2022 image.",
			"hubbleDescSpanish": "Una imagen compuesta de 2014 tomada en luz visible, infrarroja y ultravioleta, esta nebulosa está llena de cúmulos de estrellas, gas brillante y polvo espeso y oscuro.",
			"webbDescSpanish": "Al ver directamente a través del polvo cósmico con la cámara de infrarrojo cercano (NIRCam), las longitudes de onda infrarrojas exponen en esta imagen de 2022 decenas de miles de estrellas jóvenes nunca antes vistas.",
			"hubbleCredits": "Credit: NASA, ESA, E. Sabbi (STScI)",
			"webbCredits": "Credit: NASA, ESA, CSA, and STScI",
			"titleDesc": "4 Lorem ipsum dolor sit amet, consectetur adipiscing elit",
		},
		{
			"title": "Cartwheel Galaxy",
			"titleSpanish": "Galaxia Rueda de Carro",
			"beforeImage": "CartwheelGalaxy_JWST.jpg",
			"afterImage": "CartwheelGalaxy_hubble.jpg",
			"thumbnail": "CartwheelGalaxy_thumb.jpg",
			"hubbleDesc": "This 1995 visible-light image reveals the impending head-on collision between two galaxies.",
			"webbDesc": "A composite image using both the Near-Infrared Camera (NIRCam) and Mid-Infrared Instrument (MIRI) in 2022; this image displays individual stars and pockets of star formation with higher clarity and resolution.",
			"hubbleDescSpanish": "Esta imagen en luz visible de 1995 revela la inminente colisión frontal entre dos galaxias.",
			"webbDescSpanish": "Una imagen compuesta utilizando tanto la cámara de infrarrojo cercano (NIRCam) como el instrumento de infrarrojo medio (MIRI) en 2022; Esta imagen muestra estrellas individuales y focos de formación estelar con mayor claridad y resolución.",
			"hubbleCredits": "Credit: Kirk Borne (ST ScI), and NASA/ESA",
			"webbCredits": "Credit: NASA, ESA, CSA, STScI, Webb ERO Production Team",
			"titleDesc": "5 Lorem ipsum dolor sit amet, consectetur adipiscing elit",
		},
		{
			"title": "“Pillars of Creation” of the Eagle Nebula",
			"titleSpanish": "“Pilares de la Creación” en la nebulosa del Águila",
			"beforeImage": "PillarsOfCreation_JWST.jpg",
			"afterImage": "PillarsOfCreation_hubble.jpg",
			"thumbnail": "PillarsOfCreation_thumb.jpg",
			"hubbleDesc": "A 2014 image in visible light shows the dark, opaque dust in this region of space.",
			"webbDesc": "This 2022 Near-Infrared Camera (NIRCam) image uses infrared wavelengths to peer through the dark dust of this star-forming region.",
			"hubbleDescSpanish": "Una imagen del 2014 en luz visible muestra el polvo oscuro y opaco en esta región del espacio.",
			"webbDescSpanish": "Esta imagen NIRCam del 2022 utiliza longitudes de onda infrarrojas para mirar a través del polvo oscuro de esta región de formación estelar.",
			"hubbleCredits": "Credits: NASA, ESA, and the Hubble Heritage Team (STScI/AURA)",
			"webbCredits": "Credits: NASA, ESA, CSA, STScI, Joseph DePasquale (STScI), Anton M. Koekemoer (STScI), Alyssa Pagan (STScI)",
			"titleDesc": "6 Lorem ipsum dolor sit amet, consectetur adipiscing elit",
		}
	]
}

export { compareImages }